import React, { useContext, useState } from 'react';
import '../../../style.scss';
import { StoreContext } from '../../../context/StoreContext';
import { graphql, Link, useStaticQuery } from 'gatsby';
import styles from '../NavigationBar/navigationBar.module.css';
import { Col, Row } from 'react-bootstrap';
import { AiOutlineMenu, AiOutlineShoppingCart } from 'react-icons/ai';
import Nav from './Nav';
import Cart from '../Cart/Cart';
import Links from '../../Constants/Links';
import Img from 'gatsby-image';
import { v4 as uuidv4 } from 'uuid';

const query = graphql`
	{
		allContentfulHomePage {
			nodes {
				logo {
					fluid {
						...GatsbyContentfulFluid
					}
					title
				}
			}
		}
	}
`;

const NavigationBar = () => {
	const { checkout } = useContext(StoreContext);
	const [ isToggled, setIsToggled ] = useState(false);
	const [ cartIsOpen, setCartIsOpen ] = useState(false);

	const data = useStaticQuery(query);

	const qty = checkout.lineItems.reduce((total, item) => {
		return total + item.quantity;
	}, 0);
	const toggleHandler = (x) => {
		setIsToggled(!x);
	};
	const cartHandler = (x) => {
		setCartIsOpen(!x);
	};
	return (
		<header className={styles.navigationBar}>
			<Row className={styles.mobileNav}>
				<Col xs={2} style={{ paddingRight: '0rem' }} className={styles.desktopLogoHolder}>
					<Link className={`${styles.desktopLinks} ${styles.brand}`} to="/">
						<Img
							fluid={data.allContentfulHomePage.nodes[0].logo.fluid}
							alt={data.allContentfulHomePage.nodes[0].logo.title}
							style={{ margin: '0rem 1rem' }}
						/>
					</Link>
				</Col>
				<Col xs={4} md={6} className={styles.desktopLinkHolder} style={{ paddingLeft: '0rem' }}>
					<ul className={styles.desktopLinksList}>
						<Link className={`${styles.desktopLinks} ${styles.brand}`}>
							<Img
								fluid={data.allContentfulHomePage.nodes[0].logo.fluid}
								alt={data.allContentfulHomePage.nodes[0].logo.title}
							/>
						</Link>
						{Links.map((link) => (
							<Link
								className={styles.desktopLinks}
								to={link.path}
								activeStyle={{ borderBottom: '1px solid white' }}
								key={uuidv4()}
							>
								{link.text}
							</Link>
						))}{' '}
					</ul>
				</Col>

				<Col xs={3} md={5} className={styles.mobileNavHolder}>
					{isToggled ? (
						''
					) : (
						<AiOutlineMenu onClick={() => toggleHandler(isToggled)} className={styles.open} />
					)}
					<Nav toggle={isToggled} toggleHandler={toggleHandler} />{' '}
				</Col>

				<Col xs={4} sm={3} className={styles.mobileBrand}>
					<Link to="/">
						<Img
							fluid={data.allContentfulHomePage.nodes[0].logo.fluid}
							alt={data.allContentfulHomePage.nodes[0].logo.title}
						/>
					</Link>
				</Col>

				<Col xs={3} md={4} className={styles.cartHolder}>
					<Row>
						<Col xs={6} style={{ padding: '0rem' }}>
							<AiOutlineShoppingCart
								className={styles.mobileCartIcon}
								onClick={() => cartHandler(isToggled)}
							/>
						</Col>
						<Col xs={6} style={{ padding: '0rem 0.5rem', display: 'flex', alignItems: 'center' }}>
							{qty > 0 && <strong className={styles.mobileCartQuantity}>{qty}</strong>}{' '}
						</Col>
					</Row>
					<Cart cartIsOpen={cartIsOpen} cartHandler={cartHandler} />{' '}
				</Col>
			</Row>
		</header>
	);
};
export default NavigationBar;
